import { render } from "./WelcomeVdhPartner.vue?vue&type=template&id=307b34cb&scoped=true"
import script from "./WelcomeVdhPartner.vue?vue&type=script&lang=js"
export * from "./WelcomeVdhPartner.vue?vue&type=script&lang=js"

import "./WelcomeVdhPartner.vue?vue&type=style&index=0&id=307b34cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307b34cb"]])

export default __exports__